import { render, staticRenderFns } from "./iotRobot.vue?vue&type=template&id=34f129b4&scoped=true"
import script from "./iotRobot.vue?vue&type=script&lang=js"
export * from "./iotRobot.vue?vue&type=script&lang=js"
import style0 from "./iotRobot.vue?vue&type=style&index=0&id=34f129b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f129b4",
  null
  
)

export default component.exports